// pages/NewShopPage.tsx
import { useState } from "react";
import { alertSuccess, alertServerError, alertError } from "../../../helpers/alertError";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import { shopService, uploadService } from "@cabukaka/services";
import ShopForm from "../../../components/features/shops/ShopForm";
import { useAuth, useSectors, useShop, useToken } from "@cabukaka/hooks";
import { Shop } from "@cabukaka/types";

export default function NewShopPage() {
    const [isLoading, setIsLoading] = useState(false);
    const { sectors } = useSectors()
    const { user } = useAuth()
    const profile = user?.profile as Shop
    const { updateShop } = useShop({ id: profile.id })
    const { token } = useToken()

    const handleSubmit = async (data: any) => {
        setIsLoading(true);
        if (!token || !user) {
            alertError("Veillez vous connecter")
            return
        }
        try {

            const logoUrl = data.logoFile ? await uploadService.upload(data.logoFile, token) : undefined;
            const coverUrl = data.coverFile ? await uploadService.upload(data.coverFile, token) : undefined;

            const submitData = {
                name: data.name,
                description: data.description,
                phone: data.phone,
                sectorId: data.sectorId,
                open: data.open,
                deliveryTime: data.deliveryTime,
                badge: data.badge,
                location: data.location,
                logo: logoUrl, // ou l'URL récupérée après upload
                coverImage: coverUrl, // ou l'URL récupérée après upload
                id: profile.id 
            };

            if (user.role === "admin") {
                await shopService.baseService.create(submitData , token);
            } else if (user.role === "shop") {
                await updateShop(submitData);
            } else {
                alertError("Vous n'êtes pas autorisé à créer une boutique");
                return;
            }

            alertSuccess("Boutique créée avec succès");
            //navigate(-1);
        } catch (error: any) {
            alertServerError(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <PageLayout title="Nouvelle boutique">
            <PageContainer>
                <ShopForm
                    sectors={sectors}
                    onSubmit={handleSubmit}
                    isSubmitting={isLoading}
                />
            </PageContainer>
        </PageLayout>
    );
}